<div class="logosHeader">
    <mat-icon class="intosite-logo" svgIcon="intositeBlack"></mat-icon>
    <mat-icon class="sie-logo" svgIcon="sie.logo"></mat-icon>
  </div>
  <div class="content">
    <div class="tour-logout-message">
        <div class="message">
          @if (context == 'usermanagement') {
            Thank you for using the User Management.
          } @else if (context == 'rolemanagement') {
            Thank you for using the Role Management.
          } @else if (context == 'Tour') {
            Thank you for using the Intosite Tour.
          } @else if (context == 'copyLinkRedirect') {
            Please switch to the open Intosite session in your browser <br> to view the object in your facility.
          } @else if (context == 'wait') {
            Please wait...
          }
        </div>
    </div>
    <!-- <div class="bgImage"></div> -->
    <div class="gradiBg"></div>
    <div class="copyRights">
      &copy; Siemens 2025 | Siemens Digital Industries Software Inc.
    </div>
  </div>
  